// Mirrored from functions/lib/devTime.js and pinned in parity.test.ts.
//
// The form has to render the timeline choices and stop an empty request before
// it costs a round trip, and the labels are the customer-facing wording — so
// they live next to the values rather than being invented at the call site.

export const MAX_NOTE_LENGTH = 2000;

// We are not taking custom builds yet. The tab stays in the nav with a "Soon"
// tag and the page shows what is coming under a locked overlay, so nobody
// sends a request we are not ready to answer. Flip this to open it everywhere
// at once: the nav, the page, the Integrations card and Billing.
export const CUSTOM_WORK_OPEN = false;

// Whether custom work shows at all (2026-10-01: hidden). Off, there is no nav
// tab, /custom-work goes to the agent list, and the Integrations card, the
// Billing section (unless the account already has requests or orders), the
// pricing note and the FAQ sentence about it are gone. Turn it on to bring
// back the "coming soon" state; CUSTOM_WORK_OPEN then opens it.
export const CUSTOM_WORK_VISIBLE = false;

export const TIMELINES: { value: string; label: string }[] = [
  { value: "exploring", label: "Just exploring" },
  { value: "weeks", label: "In the next few weeks" },
  { value: "blocking", label: "It's blocking us right now" }
];

export const DEFAULT_TIMELINE = "weeks";

export function isValidTimeline(value: string): boolean {
  return TIMELINES.some((choice) => choice.value === value);
}

// Whether the form can be submitted. The server validates again and its answer
// is the one that counts; this only exists so the button is not live on an
// empty box.
export function canSubmitDevTimeRequest(note: string): boolean {
  const trimmed = note.trim();
  return trimmed.length > 0 && trimmed.length <= MAX_NOTE_LENGTH;
}
